import React from "react";
import { Input, Row } from "reactstrap";
import { ColPrompt } from "./index";
import { ColValue, ErrorDiv } from "../ProductionModule/index";
import { useMachineSetupContextUpdater } from "./useMachineSetupContextUpdater";
import { useMachineSetupContextState } from "./useMachineSetupContextState";
// Used by ALL machine setups

export default function RunTimeRow({ ColPromptSizeProp, ColValueSizeProp, TitleProp = "Run Time", ValueProp = "runTime" }) {
   const { handleInputTimeChange } = useMachineSetupContextUpdater();
   const { machineSetup, errorDivDefinitions } = useMachineSetupContextState();

   return (
      <Row className="mb-2">
         <ColPrompt title={TitleProp} bold={true} description={"HH:MM:SS"} sizeProp={ColPromptSizeProp} />
         <ColValue size={ColValueSizeProp || 4}>
            <Input
               type="text"
               value={machineSetup.extendedPropertyJson?.[ValueProp] || ""}
               onChange={(e) => handleInputTimeChange(e, ValueProp)}
               style={{ borderRadius: "10px", fontSize: "14px" }}
            />
            {errorDivDefinitions?.[ValueProp] && (
               <ErrorDiv>Please correct the time format (HH:MM:SS)</ErrorDiv>
            )}
         </ColValue>
      </Row>
   );
}
